module.exports = __webpack_public_path__ + "static/media/KP_02.966e5d37.jpg";